import { render, staticRenderFns } from "./SelectAddress.vue?vue&type=template&id=3e53b010&scoped=true&"
import script from "./SelectAddress.vue?vue&type=script&lang=js&"
export * from "./SelectAddress.vue?vue&type=script&lang=js&"
import style0 from "./SelectAddress.vue?vue&type=style&index=0&id=3e53b010&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e53b010",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VIcon,VImg})
